module.exports = __webpack_public_path__ + "img/5-6-3.3ffc35d5.png";